import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";

// Importar páginas
import Homepage from "./components/pages/Homepage/Homepage";
import Blog from "./components/pages/Blog/Blog";
import Contact from "./components/pages/Contact/Contact";
import PageAirSolution from "./components/pages/Solutions/PageAirSolution";
import PageHotelsSolution from "./components/pages/Solutions/PageHotelsSolution";
import PageAssistSolution from "./components/pages/Solutions/PageAssistSolution";
import PageTrainsSolutions from "./components/pages/Solutions/PageTrainsSolutions";
import PagePackagesSolutions from "./components/pages/Solutions/PagePackagesSolutions";
import PageAutomationSolution from "./components/pages/Solutions/PageAutomationSolution";
import PageDiscoverySolution from "./components/pages/Solutions/PageDiscoverySolution";
import SolutionsHub from "./components/pages/Solutions/SolutionsHub";
import Alianzas from "./components/pages/Alianzas/Alianzas";
import Documentation from "./components/pages/Documentation/Documentation";
import Nosotros from "./components/pages/Nosotros/Nosotros";
//import APIPage from "./components/pages/Documentation/APIPage";

// Importar servicios
import {
  getHomepageData,
  getHeroData,
  getSolutionsSectionData,
  getAboutSectionData,
  getPartnersSectionData,
  getValuesSectionData,
} from "./services/homepage";
import {
  getPageSolutionAirData,
  getPageSolutionHotelData,
  getPageSolutionAssistData,
  getPageSolutionTrainData,
  getPageSolutionPackageData,
  getPageSolutionAutomationsData,
  getPageSolutionDiscoveriesData,
} from "./services/pages";
import { getFooterData } from "./services/global";

import PageWrapper from "./components/pages/PageWrapper";
import NotFoundPage from "./components/pages/NotFoundPage/NotFoundPage";

const App = () => {
  return (
    <Router>
      <Header />
      <main>
        <Routes>
          {/* Homepage */}
          <Route
            path="/"
            element={
              <PageWrapper
                fetchData={async () => {
                  const [
                    homepageResponse,
                    heroResponse,
                    solutionsResponse,
                    aboutResponse,
                    partnersResponse,
                    valuesResponse,
                  ] = await Promise.all([
                    getHomepageData(),
                    getHeroData(),
                    getSolutionsSectionData(),
                    getAboutSectionData(),
                    getPartnersSectionData(),
                    getValuesSectionData(),
                  ]);
                  return {
                    homepageData: homepageResponse || {},
                    heroData: heroResponse || {},
                    solutionsData: solutionsResponse || {},
                    aboutData: aboutResponse || {},
                    partnersData: partnersResponse || {},
                    valuesData: valuesResponse || {},
                  };
                }}
                render={(data) => (
                  <Homepage
                    homepageData={data.homepageData}
                    heroData={data.heroData}
                    solutionsData={data.solutionsData}
                    aboutData={data.aboutData}
                    partnersData={data.partnersData}
                    valuesData={data.valuesData}
                  />
                )}
              />
            }
          />

          {/* Soluciones */}
          <Route
            path="/solutions/air"
            element={
              <PageWrapper
                fetchData={getPageSolutionAirData}
                render={(data) => <PageAirSolution pageAirData={data} />}
              />
            }
          />
          <Route
            path="/solutions/assist"
            element={
              <PageWrapper
                fetchData={getPageSolutionAssistData}
                render={(data) => <PageAssistSolution pageAssistData={data} />}
              />
            }
          />
          <Route
            path="/solutions/hotels"
            element={
              <PageWrapper
                fetchData={getPageSolutionHotelData}
                render={(data) => <PageHotelsSolution pageHotelData={data} />}
              />
            }
          />
          <Route
            path="/solutions/trains"
            element={
              <PageWrapper
                fetchData={getPageSolutionTrainData}
                render={(data) => <PageTrainsSolutions pageTrainData={data} />}
              />
            }
          />
          <Route
            path="/solutions/tour-circuits"
            element={
              <PageWrapper
                fetchData={getPageSolutionPackageData}
                render={(data) => <PagePackagesSolutions pageTrainData={data} />}
              />
            }
          />
          <Route
            path="/solutions/automation"
            element={
              <PageWrapper
                fetchData={getPageSolutionAutomationsData}
                render={(data) => (
                  <PageAutomationSolution pageAutomationData={data} />
                )}
              />
            }
          />
          <Route
            path="/solutions/discovery"
            element={
              <PageWrapper
                fetchData={getPageSolutionDiscoveriesData}
                render={(data) => (
                  <PageDiscoverySolution pageDiscoveryData={data} />
                )}
              />
            }
          />

          {/* Otras páginas */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/solutions" element={<SolutionsHub />} />
          <Route path="/alianzas" element={<Alianzas />} />
          <Route path="/docs/:slug" element={<Documentation />} />
          <Route path="/docs" element={<Documentation />} />
          <Route path="/nosotros" element={<Nosotros />} />

          {/* Página de error 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer
        footerData={async () => {
          const footerResponse = await getFooterData();
          return footerResponse || {};
        }}
      />
    </Router>
  );
};

export default App;
